// World City card game data with rankings
export const WORLD_CITY_CARDS = [
  { id: 1, name: "Tokyo", rank: 1, image: "/images/worldCity/worldCity_1.jpg" },
  { id: 2, name: "Delhi", rank: 2, image: "/images/worldCity/worldCity_2.jpg" },
  { id: 3, name: "Shanghai", rank: 3, image: "/images/worldCity/worldCity_3.jpg" },
  { id: 4, name: "São Paulo", rank: 4, image: "/images/worldCity/worldCity_4.jpg" },
  { id: 5, name: "Mexico City", rank: 5, image: "/images/worldCity/worldCity_5.jpg" },
  { id: 6, name: "Cairo", rank: 6, image: "/images/worldCity/worldCity_6.jpg" },
  { id: 7, name: "Mumbai", rank: 7, image: "/images/worldCity/worldCity_7.jpg" },
  { id: 8, name: "Beijing", rank: 8, image: "/images/worldCity/worldCity_8.jpg" },
  { id: 9, name: "Dhaka", rank: 9, image: "/images/worldCity/worldCity_9.jpg" },
  { id: 10, name: "Osaka", rank: 10, image: "/images/worldCity/worldCity_10.jpg" },
  { id: 11, name: "New York City", rank: 11, image: "/images/worldCity/worldCity_11.jpg" },
  { id: 12, name: "Tehran", rank: 12, image: "/images/worldCity/worldCity_12.jpg" },
  { id: 13, name: "Karachi", rank: 13, image: "/images/worldCity/worldCity_13.jpg" },
  { id: 14, name: "Kolkata", rank: 14, image: "/images/worldCity/worldCity_14.jpg" },
  { id: 15, name: "Buenos Aires", rank: 15, image: "/images/worldCity/worldCity_15.jpg" },
  { id: 16, name: "Chongqing", rank: 16, image: "/images/worldCity/worldCity_16.jpg" },
  { id: 17, name: "Istanbul", rank: 17, image: "/images/worldCity/worldCity_17.jpg" },
  { id: 18, name: "Manila", rank: 18, image: "/images/worldCity/worldCity_18.jpg" },
  { id: 19, name: "Lagos", rank: 19, image: "/images/worldCity/worldCity_19.jpg" },
  { id: 20, name: "Rio de Janeiro", rank: 20, image: "/images/worldCity/worldCity_20.jpg" },
  { id: 21, name: "Tianjin", rank: 21, image: "/images/worldCity/worldCity_21.jpg" },
  { id: 22, name: "Kinshasa", rank: 22, image: "/images/worldCity/worldCity_22.jpg" },
  { id: 23, name: "Guangzhou", rank: 23, image: "/images/worldCity/worldCity_23.jpg" },
  { id: 24, name: "Los Angeles", rank: 24, image: "/images/worldCity/worldCity_24.jpg" },
  { id: 25, name: "Moscow", rank: 25, image: "/images/worldCity/worldCity_25.jpg" },
  { id: 26, name: "Shenzhen", rank: 26, image: "/images/worldCity/worldCity_26.jpg" },
  { id: 27, name: "Lahore", rank: 27, image: "/images/worldCity/worldCity_27.jpg" },
  { id: 28, name: "Bengaluru", rank: 28, image: "/images/worldCity/worldCity_28.jpg" },
  { id: 29, name: "Paris", rank: 29, image: "/images/worldCity/worldCity_29.jpg" },
  { id: 30, name: "Bogotá", rank: 30, image: "/images/worldCity/worldCity_30.jpg" }
];
